import React from 'react';
import { Avatar } from '@material-ui/core'
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react'
import './locationMap.css';

const infoWindowStylesBusinessName = (businessName) => {
  return {
      /*textOverflow: window.innerWidth > 1400 && businessName.length > 29 ? 'ellipsis' : 'inherit !important',
      width: window.innerWidth > 1400 ? (businessName.length > 29 ? '100px' : '100%') : '100px'*/
      textOverflow: businessName.length > 10 ? 'ellipsis !important' : 'clip !important',
      width: businessName.length > 10 ? '150px' : '100px'
  }
}

const infoWindowStylesBusinessAddress = (businessName, address) => {
  return {
      /*textOverflow: (window.innerWidth >= 960 && window.innerWidth <= 1400) || (businessName.length > 29 || address.length > 42) ? 'ellipsis' : 'inherit !important',
      width: (window.innerWidth >= 960 && window.innerWidth <= 1400) || (businessName.length > 29 || address.length > 42) ? '100px' : '100%',
      overflow: (window.innerWidth >= 960 && window.innerWidth <= 1400) || (businessName.length > 29 || address.length > 42) ? 'hidden' : 'visible',
      whiteSpace: (window.innerWidth >= 960 && window.innerWidth <= 1400) || (businessName.length > 29 || address.length > 42) ? 'nowrap' : 'normal'*/
      width: businessName.length > 10 || address.length > 10 ? '150px' : '100px',
      overflow: businessName.length > 10 || address.length > 10 ? 'hidden' : 'visible',
      textOverflow: businessName.length > 10 || address.length > 10 ? 'ellipsis !important' : 'clip !important',
      whiteSpace: businessName.length > 10 || address.length > 10 ? 'nowrap' : 'normal'

  }
}

const defaultProps = {
  zoom: 11,
  info: {
    textAlign: 'center',
    display: 'flex',
    width: '150px'
  },
  window:{
  textAlign: 'left',
    paddingLeft:'5px'
  }

}
class LocationMap extends React.Component{
  constructor(){
    super()
    this.state = {
      temp: false,
      deals:{},
      user:{}
    }
  }
  componentWillMount () {
      setTimeout(() => {
        this.setState({
          temp: true,
        })
      }, 100)
  }
  checkProfileImg=(url)=>{
    const {user}=this.props;
    if(url=== null || url==="" ){
      return <img  src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} className="info-window-avatar-img"/>
    }else{
      return <img  src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${user.results.AppUser.ProfileImage}`} className="info-window-avatar-img"/>
    }
  };
  infoWindow = () => {
    let { user,deals }=this.props;
    return (
      <div>{user &&
      <div>{deals
        ?
      <div className={"info"}>
      <div className={"address-text"} style={{margin: '0px 0px 12px 0px'}}><Avatar>
        {this.checkProfileImg(user.results.AppUser.ProfileImage)}
      </Avatar></div>
      <div style={defaultProps.window}>
        <div className={"infoOffer"} style={infoWindowStylesBusinessName(user.results.AppUser.FirstName)}>{user && user.results.AppUser.FirstName}</div>
        <div style={infoWindowStylesBusinessAddress(user.results.BusinessUser.Address)}>
          <span className={"infoOffer"}>{deals && deals.Title}</span>
          <span>{deals.Description && ` - ${deals.Description}`}</span>
        </div>
      </div>
      </div>
      : <div className={"info"}>
          <div className={"address-text"} style={{margin: '0px 0px 12px 0px'}}>
            <Avatar className={"info-img"}>
              {this.checkProfileImg(user.results.AppUser.ProfileImage)}
            </Avatar>
          </div>
          <div style={defaultProps.window}>
            <div style={defaultProps.window} >
              <div className={"infoOffer"} style={infoWindowStylesBusinessName(user.results.AppUser.FirstName)}>{user && user.results.AppUser.FirstName}</div>
              <div style={infoWindowStylesBusinessAddress(user.results.AppUser.FirstName, user.results.BusinessUser.Address)}>
                {user.results.BusinessUser.Address}
              </div>
            </div>
          </div>
        </div>
      }
    </div>}
    </div>)

  };
  render(){
    let {mapData} =this.props;
    let {user,google}=this.props;
    return(
      <div style={{position:'relative',width:'100%',height:mapData.height}}>
      <Map
          className="map-size-class"
        style={{width:'100%', height:mapData.height}}
        google={this.props.google} zoom={16}
        initialCenter={{
          lat: user && user.results.BusinessUser.Address_Lat,
          lng: user && user.results.BusinessUser.Address_Long
        }}
        fullscreenControl={false}
        streetViewControl={false}
        disableDoubleClickZoom={true}
        mapTypeControl={false}
        scrollwheel={false}
        draggable={false}
        disableDefaultUI={true}
      >
        <Marker
          icon={{
            url: require(`../../../images/location_32px.png`)
          }}/>
        <InfoWindow
          position={{lat:user && user.results.BusinessUser.Address_Lat, lng: user && user.results.BusinessUser.Address_Long}}
          visible={true}
          options={{pixelOffset: new google.maps.Size(0,-13)}}
          >
          {this.infoWindow()}
        </InfoWindow>
      </Map>
      </div>
    )
  }
}
export default GoogleApiWrapper({
  apiKey: ('AIzaSyDOEDrHL3W3HUA6hk2u59bITUj-a2HgO4U')
})(LocationMap)